import { useRef } from 'react';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';

export default function Tooltip({ content, children, placement, allowCopy }) {
  const toCopy = useRef(null);
  void allowCopy;

  const renderTooltip = props => (
    <BootstrapTooltip {...props}>
      <div ref={toCopy} className="font-weight-bold">
        {content || children}
      </div>
    </BootstrapTooltip>
  );

  return (
    <OverlayTrigger placement={placement} overlay={renderTooltip} trigger={['hover', 'focus']}>
      <span className="cursor-pointer flex items-center">{children}</span>
    </OverlayTrigger>
  );
}
